import { hydraUiApi } from '@/services/api';

export type GatedFeatureRequester = {
  accountId: number;
  featureName: string;
  requester: string;
  requesterEmail: string;
  requesterUserId: number;
};

/**
 * Record a `gated_feature_interaction` track event against the account. This is
 * the CIO event the sales team's "interested in Premium" journey is triggered
 * by — a port of the Ember gated-features CTA's `api.post('track', { pathScope:
 * 'account', ... })` call, sent through the same account track-event endpoint
 * the analytics service uses.
 */
export async function postGatedFeatureInteraction({
  accountId,
  featureName,
  requester,
  requesterEmail,
  requesterUserId,
}: GatedFeatureRequester): Promise<void> {
  await hydraUiApi.tracking.createTrackEventForAccount({
    params: { path: { account_id: String(accountId) } },
    body: {
      event: 'gated_feature_interaction',
      properties: {
        account_id: accountId,
        feature_name: featureName,
        requester,
        requester_email: requesterEmail,
        requester_user_id: requesterUserId,
        interaction_type: 'upgrade',
        additional_info: '',
      },
    },
  });
}
